import { render, staticRenderFns } from "./ColumnSettingsDialog.vue?vue&type=template&id=45189ab3&scoped=true&"
import script from "./ColumnSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./ColumnSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ColumnSettingsDialog.vue?vue&type=style&index=0&id=45189ab3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45189ab3",
  null
  
)

export default component.exports